import React from 'react';
import { Navigate, useRoutes } from 'react-router';
import TitledPage from 'components/common/TitledPage';
import { useAssetAccess } from 'components/asset-access';
import { AccessibleSubNav } from 'features/AccessibleSubNav';
import {
  StyledSectionSubnav,
  StyledSubnavHeader,
} from 'pages/learning/landing/LearningSubNav';
import styled from 'styled-components';
import { lazyWithRetries } from 'components/routes/lazyWithRetries';

const MatterNewRoute = lazyWithRetries(
  () => import('pages/matters/matter/New'),
);
const MatterDocsAndFormsTrueFormRoute = lazyWithRetries(
  () => import('components/matters/matter/form/TrueForm'),
);
const MatterRoute = lazyWithRetries(() => import('pages/matters/matter/index'));
const MatterClientRoute = lazyWithRetries(
  () => import('pages/matters/client/index'),
);
const MattersLandingRoute = lazyWithRetries(
  () => import('pages/matters/landing/index'),
);

const mattersRoutes = [
  {
    path: '/new',
    element: <MatterNewRoute />,
  },
  {
    path: '/:id/new',
    element: <MatterNewRoute />,
  },
  {
    path: '/matter/:id/documents_and_forms/:slug/:formId',
    element: <MatterDocsAndFormsTrueFormRoute />,
  },
  {
    path: '/matter/:id/*',
    element: <MatterRoute />,
  },
  {
    path: '/:id',
    element: <MatterClientRoute />,
  },
  {
    index: true,
    element: <MattersLandingRoute />,
  },
];

export interface ClientMattersProps {
  title?: string;
}

export default function ClientMatters({ title }: ClientMattersProps) {
  const assetAccess = useAssetAccess();
  const routes = useRoutes(mattersRoutes);

  if (!assetAccess?.hasFormsAndMatters) {
    return <Navigate to="/" />;
  }

  return (
    <>
      <TitledPage title={title}>{routes}</TitledPage>
    </>
  );
}

export const MattersSubNav = () => {
  return (
    <StyledMattersSubNav>
      <StyledSectionSubnav>
        <AccessibleSubNav />
      </StyledSectionSubnav>
    </StyledMattersSubNav>
  );
};

const StyledMattersSubNav = styled(StyledSubnavHeader)`
  align-self: end;
  flex: 1 1 100%;
  justify-content: start;
  padding-bottom: 5px;
  display: flex;
  margin-bottom: 0;
  border-bottom: none;
`;
